import Vue from 'vue'
import store from '@/store'
Vue.directive('loadmore', {
	bind(el, binding) {
		// 获取element-ui定义好的scroll盒子
		const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
		SELECTWRAP_DOM.addEventListener('scroll', function () {
			const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
			if (CONDITION) {
				binding.value()
			}
		})
	}
})
Vue.directive('focus', {
	inserted: function (el) {
		el.children[0].focus()
	}
})
const findItemByName = (arr, targetName) => {
	for (let item of arr) {
		if (item.name == targetName.trim()) {
			return item
		}
		if (item.children && item.children.length > 0) {
			const foundInChildren = findItemByName(item.children, targetName)
			if (foundInChildren) {
				return foundInChildren
			}
		}
	}
	return null
}

export const permissions = targetNames => {
	if (store.state.user.userInfo.type == 6) {
		let isPermission = targetNames.map(item => {
			return !!findItemByName(store.state.menu, item)
		})
		// return isPermission.every(item => item == true)
		return isPermission.some(item => item == true)
	} else {
		return true
	}
}

Vue.directive('permission', {
	bind(el, binding) {},
	inserted: function (el, binding) {
		const permission = binding.value
		const item = findItemByName(store.state.menu, permission)
		if (store.state.user.userInfo.type == 6) {
			const hasPermission = !!item
			if (!hasPermission) {
				el.style.display = 'none'
			} else {
				el.style.display = ''
			}
		}
	}
})
